<template>
  <v-layout class="justify-space-between">
    <!-- <code>{{currentTeam}}</code> -->

    <v-flex xs4>
      <address-display :object="document.user" title="Quote by:" class="proposal-header__block"></address-display>
    </v-flex>

    <transition name="fade">
      <v-flex xs4 v-if="showCustomer">
        <address-display
          :object="document"
          prefix="customer_"
          title="Prepared for:"
          class="proposal-header__block"
        ></address-display>
      </v-flex>
    </transition>

    <v-flex xs4 class="py-0">
      <v-layout column fill-height class="my-0">
        <v-flex
          v-if="!document.for_customer || ((user.logo_url && typeof user.logo_url === 'string') || user.company)"
        >
          <transition-group
            name="cards"
            tag="div"
            class="text-xs-right proposal-header__block"
            appear
          >
            <span
              v-if="!document.for_customer"
              class="proposal-logo"
              :style="`background-image: url(${currentTeam.photo_url_dark})`"
              key="team-logo"
            ></span>

            <span
              v-else-if="user.logo_url && typeof user.logo_url === 'string'"
              class="proposal-logo"
              :style="`background-image: url(${user.logo_url})`"
              key="dealer-logo"
            ></span>

            <h2
              v-else
              style="line-height: 1.2;"
              key="company-name"
              class="text-xs-right"
            >{{ user.company }}</h2>
          </transition-group>
        </v-flex>

        <v-flex shrink style="margin-top: auto;">
          <div class="text-xs-right address proposal-header__block">
            <span class="address__line">{{document.number}}</span>
            <span class="address__line font-weight-bold">{{document.name}}</span>
            <span v-if="document.sap_quotation_number" class="address__line font-weight-bold">SAP Quotation #: {{document.sap_quotation_number}}</span>
            <span
              v-if="document.ordered_at"
              class="address__line"
            >Ordered on: {{ document.ordered_at | moment("MMM D YYYY") }}</span>
            <span
              v-else
              class="address__line"
            >Proposed on: {{ document.proposal_date | moment("MMM D YYYY") }}</span>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import AddressDisplay from "@components/partials/AddressDisplay";
var { quoteBuilder } = require("@root/mixins");

export default {
  mixins: [quoteBuilder],

  components: { AddressDisplay },

  computed: {
    ...mapGetters(["user", "currentTeam"]),

    user_phone() {
      return this.getObjectValue(
        "user.phone",
        this.document,
        this.getObjectValue("user.cell_phone", this.document, "")
      );
    },

    showCustomer() {
      return (
        this.document.for_customer &&
        (this.document.customer_name || this.documentcustomer_company)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.proposal-logo {
  display: block;
  height: 100%;
  width: 100%;
  min-height: 50px;
  background-position: center right;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
